import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  "https://qhftgrfpkamqjrkutuxt.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFoZnRncmZwa2FtcWpya3V0dXh0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY4MDU4NDMsImV4cCI6MjA5MjM4MTg0M30.LOtLy_NgNxKHtsCAR_VD0To1wgK9NaB1l23SVxnD4Qk"
);